module.exports = __webpack_public_path__ + "static/media/abdulrahman.95235593.jpg";